module.exports = __webpack_public_path__ + "static/003_001-67e193ce8b0e9ebe75cb0ec1238c817b.jpg";